import _ from "lodash";
import { Coordinate } from "../types/analytics";

export const roundTo2dp = (number: number): number => roundToDp(2, number);

export const showTo2dp = (number: number): string => roundTo2dp(number).toFixed(2);

/**
 * Rounds a value to a given number of decimal places.
 * @param {number} dp number of decimal places (must be >= 1)
 * @param {number} number number to round
 * @returns {number} rounded number
 */
export const roundToDp = (dp: number, number: number): number => Math.round((number + Number.EPSILON) * Math.pow(10, dp)) / (Math.pow(10, dp));

export const getUniqueNonUniqueValues = (array: any[]): string[] => _.keys(_.pickBy(_.groupBy(array), group => group.length > 1));

export const roundToHundred = (num: number): number => {
  return Math.round(num / 100) * 100;
};

export const getRoundedCoordinates = (coords: Coordinate[]): Coordinate[] => {
    const roundedCoords = coords.map(point => 
        [Math.round(point[0] * 100) / 100000, Math.round(point[1] * 100) / 100000] as Coordinate
    );
    return roundedCoords;
};